import { gateway } from "src/gateway";

export interface ConfigurationItem {
  uid: string;
  name: string;
  value: string;
  description: string;
  createdAt: string;
  updatedAt: string;
}

export interface ConfigurationResponse {
  status: number;
  message: string;
  data: ConfigurationItem[];
}

export const fetchSetupFees = async (): Promise<ConfigurationItem[]> => {
  const token = sessionStorage.getItem("token");
  const { data } = await gateway.get<ConfigurationResponse>("/configurations?names=PORTING_SETUP_FEE,BUYING_SETUP_FEE", {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  return data.data;
};
